import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuItem } from "@mui/material";
import { switchStoreId } from "../redux/user/slice";
import { getStoreId, getStores } from "../redux/selectors";

export const MenuStores = ({ anchorEl, open, handleClose }) => {
  const dispatch = useDispatch();
  const storeId = useSelector(getStoreId);
  const stores = useSelector(getStores);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      {stores.map((store) => (
        <MenuItem
          key={store._id}
          onClick={() => {
            dispatch(switchStoreId(store._id));
            handleClose();
          }}
        >
          <span
            className={`inline-block ${
              storeId === store._id ? "bg-mainRed" : "bg-transparent"
            } rounded-full h-2 w-2 -ml-2 mr-1`}
          ></span>
          Multicook {store.title}
        </MenuItem>
      ))}
    </Menu>
  );
};
